export default __webpack_public_path__ + "static/media/tuna-marinara.68113d0f.jpg";